import React from 'react'
import { Link } from 'react-router-dom'

// Standardised section header used by homepage rails and listing pages.
// Layout: [eyebrow chip][title H2][subtitle] ............... [CTA →]
//
// Usage:
//   <SectionHeader
//     eyebrow={{ icon: <FaFire />, label: 'Həftənin fürsətləri', tone: 'accent' }}
//     title='Həftənin Fürsətləri'
//     subtitle='Seçilmiş fürsət elanları və vitrin rozetləri.'
//     action={{ to: '/haftanin-firsatlari', label: 'Hamısına bax' }}
//   />

const EYEBROW_TONE = {
  brand:   'bg-brand-50 text-brand-700',
  accent:  'bg-accent-50 text-accent-700',
  success: 'bg-success-50 text-success-700',
  danger:  'bg-danger-50 text-danger-700',
  warning: 'bg-warning-50 text-warning-700',
  neutral: 'bg-slate-100 text-slate-700',
}

const Arrow = () => (
  <svg className='w-4 h-4 transition-transform group-hover:translate-x-1' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
  </svg>
)

const SectionHeader = ({
  eyebrow,
  title,
  subtitle,
  action,
  align = 'between',
  className = '',
}) => {
  const eyebrowTone = EYEBROW_TONE[eyebrow?.tone] || EYEBROW_TONE.brand

  return (
    <div className={`mb-6 flex flex-wrap items-end justify-${align === 'center' ? 'center' : 'between'} gap-4 ${className}`}>
      <div className={align === 'center' ? 'text-center w-full' : ''}>
        {eyebrow?.label && (
          <div className={`mb-2 inline-flex items-center gap-1.5 rounded-pill px-3 py-1 text-[11px] font-bold uppercase tracking-wider ${eyebrowTone}`}>
            {eyebrow.icon}
            <span>{eyebrow.label}</span>
          </div>
        )}
        {title && (
          <h2 className='relative pl-3 text-2xl sm:text-xl font-black text-slate-900 leading-tight before:absolute before:left-0 before:top-1.5 before:bottom-1.5 before:w-1 before:rounded-pill before:bg-brand-600'>
            {title}
          </h2>
        )}
        {subtitle && (
          <p className='mt-1 pl-3 text-sm text-slate-500 max-w-xl'>{subtitle}</p>
        )}
      </div>

      {action?.to && (
        <Link
          to={action.to}
          className='group inline-flex items-center gap-1.5 rounded-card border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-brand-400 hover:text-brand-700'
        >
          {action.label || 'Hamısına bax'}
          <Arrow />
        </Link>
      )}
    </div>
  )
}

export default SectionHeader
